import { render, staticRenderFns } from "./dataTable.vue?vue&type=template&id=5874a666&scoped=true"
import script from "./dataTable.vue?vue&type=script&lang=js"
export * from "./dataTable.vue?vue&type=script&lang=js"
import style0 from "./dataTable.vue?vue&type=style&index=0&id=5874a666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874a666",
  null
  
)

export default component.exports